import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./TitledContainer.css";

const StaticText = ({ isGray, isImportant, text }) => (
  <div
    className={classnames(styles.text, {
      [styles.important]: isImportant,
      [styles.gray]: isGray,
    })}
  >
    {text}
  </div>
);

StaticText.propTypes = {
  isImportant: PropTypes.bool,
  isGray: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default StaticText;
